// MENU 

console.log('test')
const nyselect = document.getElementById('ny-select')
const loselect = document.getElementById('lo-select')
const nymenu = document.getElementById('ny-menu')
const lomenu = document.getElementById('lo-menu')
const pageTitle = document.getElementById('title')
const aboutLink = document.getElementById('about')
const aboutText = document.getElementById('about-text')
const mainNav = document.getElementById('main')
const contentCol = document.getElementById('content-col')
const contentArea = document.getElementById('content-area')

nyselect.addEventListener('click', (e) => {
	clearBoth()
	nyselect.classList.toggle('active')
	mainNav.classList.add('active')
	nyselect.ariaExpanded = nyselect.ariaExpanded !== 'true'
	nymenu.classList.add('expanded')
	lomenu.classList.remove('expanded')
	loselect.classList.remove('active')
	aboutLink.classList.add('hide')
})

loselect.addEventListener('click', (e) => {
	clearBoth()
	loselect.classList.toggle('active')
	mainNav.classList.add('active')
	loselect.ariaExpanded = loselect.ariaExpanded !== 'true'
	lomenu.classList.add('expanded')
	nymenu.classList.remove('expanded')
	nyselect.classList.remove('active')
	aboutLink.classList.add('hide')
})

// LIGHTBOX CONTENT

const menuitems = document.querySelectorAll('.menu-item')
const menuitemsNy = document.querySelectorAll('#ny-menu .menu-item')
const menuitemsLo = document.querySelectorAll('#lo-menu .menu-item')
const header = document.getElementById('main-menu')

function showContent(section, loc, e) {
	contentCol.classList.toggle('active')
	contentCol.ariaHidden = contentCol.ariaHidden !== 'true'
	header.classList.toggle('hide')
	aboutText.classList.add('hide')

	let contentEl = document.getElementById(section)
	let content = contentEl.outerHTML

	contentArea.innerHTML+= content
	contentCol.classList.add(loc)
	console.log(loc)
}

function clearContent() {
	// lightbox.classList.toggle('active')
	contentCol.ariaHidden = contentCol.ariaHidden !== 'true'
	header.classList.toggle('hide')	
	aboutText.classList.remove('hide')

	setTimeout(() => {
		contentArea.innerHTML = ''
	}, 0 )
	menuitems.forEach(function(item) {
		item.classList.remove('active')
	})
	contentCol.classList.value = ''
}

function clearBoth() {
	if (contentCol.ariaHidden) {
		contentCol.ariaHidden = 'true'
	}
	// contentCol.ariaHidden = contentCol.ariaHidden !== 'true'
	setTimeout(() => {
		contentArea.innerHTML = ''
		contentCol.dataset.location = ''
	}, 0 )
	contentCol.classList.value = ''
	header.classList.remove('hide')	
	menuitems.forEach(function(item) {
		item.classList.remove('active')
	})
}

menuitems.forEach(function (item) {
	const section = item.dataset.section
	const loc = item.dataset.loc

	item.addEventListener('click', function(e){
		clearBoth()
		setTimeout(() => {
			showContent(section, loc, e)
			this.classList.toggle('active')
		}, 100)
	}, false)
}) 

// const close = document.getElementById('close')

// close.addEventListener('click', (e) => {
// 	clearContent()
// })

window.addEventListener("load", (event) => {
  header.classList.add('loaded')
})